import React, { useState, useEffect, useRef } from "react";
import CustomCardSlider from "../../Components/CardSlider/card-slider";
import "swiper/css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";
import { useSelector } from "react-redux";
import { currentAppUrl } from "../../Constants/config";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement);

const DashboardDetails = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const cardCurrencyName = useSelector((state) => state.user.cardCurrencyName);
  const loggedInUserRole = useSelector((state) => state.user.roleName);
  const { showToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [cardDatanew, setcardData] = useState([]);
  const cardActivated = useSelector((state) => state.cards.cardExisted);
  const [defaultCard, setDefaultCard] = useState({});
  const searchParams = new URLSearchParams(location.search);
  const cardId = searchParams.get("cardId");

  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const GetAPIcallsFromPrev = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getCardData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(loggedInUserRole=="advisor"?`${BASE_URL}/v1/advisor/dashboard/stats?currency=${cardCurrencyName.label}`:
        `${BASE_URL}/v1/dashboard/stats?currency=${cardCurrencyName.label}`
      );
      if (response.status == 200) {
        // const responseCurrentSystem = await GetAPIcalls(
        //   `${currentAppUrl}/api/customer-account-balance`
        // );
        const responseCurrentSystem = {
          status: "success",
          data: {
            accounts: {
              "Cash Account": 4165868.76,
              "Fund Management": 0,
              Securities: 0,
              "Trading Account": 0,
              "Private Wealth": 102516383,
              Custodian: 0,
              "My Investment - SMA": 484643.7,
              "Digital Assets ": 3295337492,
            },
          },
        };
        if (responseCurrentSystem.status == "success") {
          // if (response.status == 200) {
          const cardData = [
            {
              label: "Cash Account",
              id: "1",
              amount: response.data.total_cashaccount.total_balance
                ? response.data.total_cashaccount.total_balance.toFixed(2)
                : "0.00",
              accounts: 2,
              isLocked: false,
              color: "bg-[#5D88F8] bg-opacity-100",
              lessColor: "bg-[#5D88F8] bg-opacity-40",
              tail: "border-t-[#5D88F8] border-b-[#5D88F8]  border-opacity-100",
              graphdata: {
                labels: response.data.total_cashaccount.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.total_cashaccount.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Portfolio Management Account",
              id: "2",
              amount: response.data.fund_management.total_balance
                ? response.data.fund_management.total_balance.toFixed(2)
                : "0.00",
              isLocked: false,

              accounts: 1,
              color: "bg-[#996EE7] bg-opacity-100",
              lessColor: "bg-[#996EE7] bg-opacity-40",
              tail: "border-t-[#996EE7] border-opacity-100",

              graphdata: {
                labels: response.data.fund_management.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.fund_management.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Securities",
              id: "3",
              amount: responseCurrentSystem.data.accounts.Securities
                ? responseCurrentSystem.data.accounts.Securities.toFixed(2)
                : "0.00",
              accounts: 1,
              isLocked: false,

              color: "bg-[#F18C29] bg-opacity-100",
              lessColor: "bg-[#F18C29] bg-opacity-40",
              tail: "border-t-[#F18C29] border-opacity-100",
              graphdata: {
                labels: response.data.total_securities.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.total_securities.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Fund Management",
              id: "4",
              amount: responseCurrentSystem.data.accounts["Fund Management"]
                ? responseCurrentSystem.data.accounts[
                    "Fund Management"
                  ].toFixed(2)
                : "0.00",
              accounts: 2,
              isLocked: false,

              color: "bg-[#DC4646] bg-opacity-100",
              lessColor: "bg-[#DC4646] bg-opacity-40",
              tail: "border-t-[#DC4646] border-opacity-100",
              graphdata: {
                labels: response.data.total_tradings.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.total_tradings.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Custodian",
              id: "5",
              amount: responseCurrentSystem.data.accounts.Custodian
                ? responseCurrentSystem.data.accounts.Custodian.toFixed(2)
                : "0.00",
              accounts: 0,
              isLocked: false,

              color: "bg-[#2DB0EC] bg-opacity-100",
              lessColor: "bg-[#2DB0EC] bg-opacity-40",
              tail: "border-t-[#2DB0EC] border-opacity-100",

              graphdata: {
                labels: response.data.total_custodians.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.total_custodians.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "My Investments",
              id: "6",
              amount: responseCurrentSystem.data.accounts["My Investment - SMA"]
                ? responseCurrentSystem.data.accounts[
                    "My Investment - SMA"
                  ].toFixed(2)
                : "0.00",
              accounts: 0,
              isLocked: false,

              color: "bg-[#6B68F2] bg-opacity-100",
              lessColor: "bg-[#6B68F2] bg-opacity-40",
              tail: "border-t-[#6B68F2] border-opacity-100",

              graphdata: {
                labels: response.data.my_investments.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.my_investments.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Digital Assets",
              id: "7",
              amount: responseCurrentSystem.data.accounts["Digital Assets "]
                ? responseCurrentSystem.data.accounts[
                    "Digital Assets "
                  ].toFixed(2)
                : "0.00",
              accounts: 0,
              isLocked: false,

              lessColor: "bg-[#34C046] bg-opacity-40",
              color: "bg-[#34C046] bg-opacity-100",
              tail: "border-t-[#34C046] border-opacity-100",

              graphdata: {
                labels: response.data.digital_assets.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.digital_assets.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Property",
              id: "8",
              amount: response.data.digital_assets.total_balance
                ? response.data.digital_assets.total_balance.toFixed(2)
                : "0.00",
              accounts: 0,
              isLocked: false,

              lessColor: "bg-[#0F172A] bg-opacity-40",
              color: "bg-[#0F172A] bg-opacity-100",
              tail: "border-t-[#0F172A] border-opacity-100",

              graphdata: {
                labels: response.data.digital_assets.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.digital_assets.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
            {
              label: "Trading",
              id: "9",
              amount: response.data.digital_assets.total_balance
                ? response.data.digital_assets.total_balance.toFixed(2)
                : "0.00",
              accounts: 0,
              isLocked: false,

              lessColor: "bg-[#6B8E23] bg-opacity-40",
              color: "bg-[#6B8E23] bg-opacity-100",
              tail: "border-t-[#6B8E23] border-opacity-100",

              graphdata: {
                labels: response.data.digital_assets.daily_transactions.map(
                  (item) => item.date
                ),
                datasets: [
                  {
                    data: response.data.digital_assets.daily_transactions.map(
                      (item) => item.amount
                    ),
                    borderColor: "black",
                    backgroundColor: (context) => {
                      const chart = context.chart;
                      const { ctx, chartArea } = chart;

                      if (!chartArea) {
                        return null; // Wait until the chart is fully rendered
                      }

                      const gradient = ctx.createLinearGradient(
                        0,
                        chartArea.top,
                        0,
                        chartArea.bottom
                      );
                      gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
                      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

                      return gradient;
                    },
                    borderWidth: 2,
                    fill: true,
                  },
                ],
              },
            },
          ];
          setcardData(cardData);
          const defaultCard = cardData.find(
            (card) => card.id === cardActivated
          );
          if (cardId) {
            setDefaultCard(cardData[cardId]);
          } else {
            setDefaultCard(defaultCard || cardData[0]);
          }
        } else {
          setcardData([]);
          setDefaultCard({});
          showToast(response.message, "error");
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setcardData([]);
          setDefaultCard({});
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      setcardData([]);
      setDefaultCard({});
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };

  useEffect(() => {
    getCardData();
  }, [cardCurrencyName]);
  return (
    <div className="pt-4 p-2 lg:min-w-[78vw] lg:max-w-[80vw]">
      {isLoading ? (
        <div className="shimmer-container-list mb-4 ">
          {/* Creating 5 rows of shimmer effect */}
          {[...Array(2)].map((_, rowIndex) => (
            <div key={rowIndex} className="shimmer-row-list">
              {/* Creating 7 cells in each row for shimmer */}
              {[...Array(2)].map((_, colIndex) => (
                <div key={colIndex} className="shimmer-cell-list h-20">
                  <div className="shimmer-loader"></div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <CustomCardSlider
          componentName="dashboard"
          cardData={cardDatanew}
          defaultCard={defaultCard}
          ondefaultCard={(value) => setDefaultCard(value)}
        />
      )}
    </div>
  );
};

export default DashboardDetails;
